// extracted by mini-css-extract-plugin
export default {"landingImage":"Landing_landingImage__9GUU-","button":"Landing_button__BV2xz"};